/* The First Four · landing page behaviour (v2)
   Picker selection, per-fragrance info modal, add-to-bag, and the lazy
   Our Story takeover (assets load only when the link is clicked). */
(function () {
  'use strict';
  function T(s) { return window.FF_T ? window.FF_T(s) : s; } // Arabic UI dictionary (snippets/ff-ar-i18n.liquid)
  if (window.__fflpInit) return;
  window.__fflpInit = true;

  /* ============================ PICKER ============================ */
  function initPicker(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fflp-card]'));
    var countEl = root.querySelector('[data-fflp-count]');
    var cta = root.querySelector('[data-fflp-cta]');
    var ctaLabel = root.querySelector('[data-fflp-cta-label]');
    var errorEl = root.querySelector('[data-fflp-error]');
    var continueUrl = root.getAttribute('data-continue-url') || '';
    var readyLabel = root.getAttribute('data-cta-ready-label') || 'Continue with these four';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var cartAddUrl = (root.getAttribute('data-cart-add-url') || '/cart/add') + '.js';
    var busy = false;
    var selected = [];

    function render() {
      cards.forEach(function (card) {
        card.classList.toggle('is-selected', selected.indexOf(card) > -1);
      });
      if (countEl) countEl.textContent = T(selected.length + ' of 4 selected');
      var full = selected.length >= 4;
      if (cta) cta.classList.toggle('is-ready', full);
      if (ctaLabel) ctaLabel.textContent = T(full ? readyLabel : 'Select ' + (4 - selected.length) + ' more');
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-fflp-info-open]')) return;
        var i = selected.indexOf(card);
        if (i > -1) selected.splice(i, 1);
        else if (selected.length < 4) selected.push(card);
        render();
      });
    });

    if (cta) cta.addEventListener('click', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      if (selected.length < 4) {
        var track = root.querySelector('.fflp-picker__track');
        if (track) track.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (continueUrl) {
        var picks = selected.map(function (c) { return c.getAttribute('data-handle') || ''; }).filter(Boolean);
        var join = continueUrl.indexOf('?') > -1 ? '&' : '?';
        window.location.href = continueUrl + join + 'picks=' + picks.join(',');
        return;
      }
      if (busy) return;
      var items = selected.map(function (c) { return { id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: 1 }; });
      if (items.some(function (it) { return !it.id; })) {
        if (errorEl) { errorEl.hidden = false; errorEl.textContent = T('One of your four is unavailable at the moment.'); }
        return;
      }
      busy = true;
      if (ctaLabel) ctaLabel.textContent = T('Adding your four…');
      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to bag'); });
        window.location.href = cartUrl;
      }).catch(function (err) {
        busy = false;
        render();
        if (errorEl) { errorEl.hidden = false; errorEl.textContent = T(err.message || 'Could not add to bag. Please try again.'); }
      });
    });

    /* ---- Info modal ---- */
    var modal = root.querySelector('[data-fflp-info-modal]');
    var slot = modal ? modal.querySelector('[data-fflp-info-slot]') : null;

    function closeInfo() {
      if (!modal) return;
      modal.hidden = true;
      if (slot) slot.innerHTML = '';
      document.body.classList.remove('fflp-locked');
    }

    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-fflp-info-open]');
      if (opener && modal && slot) {
        e.preventDefault();
        e.stopPropagation();
        var card = opener.closest('[data-fflp-card]');
        var tpl = card ? card.querySelector('template[data-fflp-info-tpl]') : null;
        if (!tpl) return;
        slot.innerHTML = '';
        slot.appendChild(tpl.content.cloneNode(true));
        modal.hidden = false;
        document.body.classList.add('fflp-locked');
        return;
      }
      if (e.target.closest('[data-fflp-info-close]')) { closeInfo(); return; }
      if (modal && !modal.hidden && e.target === modal) closeInfo();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeInfo();
    });

    render();
  }

  /* ============================ OUR STORY (lazy) ============================ */
  var storyLoading = false;

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function loadCss(href) {
    return new Promise(function (resolve, reject) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.onload = resolve;
      l.onerror = reject;
      document.head.appendChild(l);
    });
  }

  function openStory() {
    var host = document.querySelector('[data-ffstory-host]');
    if (!host) return;
    if (window.FFStory) { window.FFStory.open(); return; }
    if (storyLoading) return;
    storyLoading = true;
    var css = host.getAttribute('data-css');
    var gsapSrc = host.getAttribute('data-gsap');
    var stSrc = host.getAttribute('data-scrolltrigger');
    var jsSrc = host.getAttribute('data-js');
    Promise.all([loadCss(css), loadScript(gsapSrc)])
      .then(function () { return loadScript(stSrc); })
      .then(function () { return loadScript(jsSrc); })
      .then(function () {
        storyLoading = false;
        if (window.FFStory) window.FFStory.open();
      })
      .catch(function () { storyLoading = false; });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fflp-picker]'), initPicker);
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-ff-story-open]');
      if (opener) { e.preventDefault(); openStory(); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
